module.exports = __webpack_public_path__ + "img/saoyisao.e47029b9.png";